<div class="main-column">
	<app-hub-nav-header
		sportCode="golf"
		currentRoute="rankings"
	></app-hub-nav-header>

	<div class="page-description" >
		<h1 class="page-title"> Golf Rankings </h1>
		<app-page-intro-copy *ngIf="trustedDesc" [html]="trustedDesc"></app-page-intro-copy>
	</div>
	<div class="knockout-section" id="knockout">
		<div class="background-color-wrap ladder-ctr" style="height: auto;">
			<div class="wc-title">{{ environment.siteTitle | uppercase }} GOLF RANKINGS</div>
			<div style="position: relative;">
				<table class="knockout-table tennis" style="position: relative;">
					<tbody>

						<tr>
							<th style="width: 30%;">PLAYER</th>
							<th>
								<div class="tennis-rank-header" (click)="golfRankingsSortToggle('rank')" [ngSwitch]="golfRankingsSort">
									<span class="to-hide">CURRENT</span>
									<span class="to-show">NOW</span>
									<fa-icon [icon]="faSortDesc" *ngSwitchCase="'rank'" aria-hidden="true"></fa-icon>
									<fa-icon [icon]="faSortAsc" *ngSwitchCase="'-rank'" aria-hidden="true"></fa-icon>
									<fa-icon [icon]="faSort" *ngSwitchDefault aria-hidden="true"></fa-icon>
								</div>
							</th>
						</tr>
						<tr *ngIf="golfRankingsLoading">
							<td colspan="5">Loading...</td>
						</tr>
						<tr *ngIf="golfRankingsError">
							<td colspan="5">
								<div class="rankings-cell-loading">
									<span>Sorry, something went wrong. Please <span class="retry-link" (click)="getGolfRankings()">try again</span>.</span>
								</div>
							</td>
						</tr>
						<tr *ngFor="let player of displayedGolfRankings">
							<td>
								<div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
									<app-flag-icon *ngIf="matchCountry(player.playerCountry | uppercase)" [countryCode]="matchCountry(player.playerCountry | uppercase)"></app-flag-icon>
									<div class="flag-placeholder" *ngIf="!matchCountry(player.playerCountry | uppercase)"></div>
									<span class="to-hide">
										<span style="text-align: left; text-transform: uppercase;">
											{{ player.playerName }}
										</span>
									</span>
									<span class="to-show">
										<span style="text-align: left; text-transform: uppercase;">
											{{ player.playerName }}
										</span>
									</span>
								</div>
								
							</td>
							<td>
								{{ player.rank }}
							</td>
						</tr>
						
					</tbody>
				</table>
			</div>

		</div>
	</div>
	<app-best-offers sportCode="GOLF" *ngIf="environment.optionalFeatures.includes('best-offers')"></app-best-offers>
	<div class="description" *ngIf="trustedCopy" [innerHTML]="trustedCopy"></div>
</div>
<!-- Arbitrary margin on this page to cause heading of first element to align with first element of main column-->
<div class="sidebar" style="margin-top: 17px;">
	<app-book-offers *ngIf="environment.optionalFeatures.includes('welcome-offers')"></app-book-offers>
    <app-legal-betting *ngIf="environment.optionalFeatures.includes('legal-betting-sidebar')"></app-legal-betting>
	<app-radar-link *ngIf="environment.siteTitle === 'Radar Sports'"></app-radar-link>
	<app-newsletter-signup-prompt *ngIf="environment.optionalFeatures.includes('newsletter')"></app-newsletter-signup-prompt>
	<app-upcoming-matches-list
		*ngIf="environment.availableSports.length > 0"></app-upcoming-matches-list>
	<!-- <app-latest-articles-list sportCode="GOLF"></app-latest-articles-list> -->
	<!-- <app-contributor-summary></app-contributor-summary> -->
	<!-- <app-twitter-embed></app-twitter-embed> -->
	<!-- <app-social-button-collection></app-social-button-collection> -->
	<app-odds-disclaimer *ngIf="environment.optionalFeatures.includes('odds-disclaimer')"></app-odds-disclaimer>
</div>
